import PropTypes from 'prop-types'
import React from 'react'
import StyleWrapper from 'common/components/StyleWrapper'
import { splitMarginsAndRestStyles } from 'common/utils/styleUtils'
import BaseField from 'publisher/components/entities/Field/BaseField'
import usePayment from 'publisher/hooks/usePayment'
import * as paymentSelectors from 'publisher/reducers/paymentReducer'
import { useOptIn } from 'publisher/store'
import { getCustomerCountry } from 'publisher/store/optIn/optInSelectors'

function CompanyVatField({ entity }) {
  const customerCountryCode = useOptIn(state => getCustomerCountry(state))
  const isPersonal = usePayment(paymentSelectors.isCustomerPersonal)

  if (typeof window === 'undefined') {
    return (
      <StyleWrapper
        desktop={entity.options.appearance.desktop}
        mobile={entity.options.appearance.mobile}
        styles={splitMarginsAndRestStyles(entity.styles)[0]}
        mobileStyles={splitMarginsAndRestStyles(entity.mobileStyles)[0]}
      />
    )
  }

  return customerCountryCode !== 'BR' && isPersonal
    ? <div />
    : <BaseField entity={entity} />
}

CompanyVatField.propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    options: PropTypes.shape({
      slug: PropTypes.string,
      placeholder: PropTypes.string,
      placeholderColor: PropTypes.string,
      appearance: PropTypes.shape({
        desktop: PropTypes.bool.isRequired,
        mobile: PropTypes.bool.isRequired,
      }).isRequired,
    }).isRequired,
    styles: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    mobileStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
      .isRequired,
    type: PropTypes.string.isRequired,
  }),
}

export default CompanyVatField
